window.isFrenzyEventApiCall = true;
const frenzy_get_product_json = async function(url, html){
  jQuery.getJSON(url, function(product) {
    document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
      const getVariantID = this_section.getAttribute("data-variantid");

      let getCurrentVariant = '';
      let newPrice = '';
      let newComparePrice = '';
      let max_price = '';
      let min_price = '';

      
      if(getVariantID.length < 14){
          getCurrentVariant = product.variants[0];
          newPrice = Math.round(getCurrentVariant.price / 100);
          newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
          max_price = product.price_max;
          min_price = product.price_min;  
      }else{
        getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
        newPrice = Math.round(getCurrentVariant.price / 100);
        newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
        max_price = product.price_max;
        min_price = product.price_min;  
      }

      var compare_price = '';
      var price = '';
      if(min_price != max_price){
          price = '<span> As low as </span>' + money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
      }else{
        price =  money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
        if(min_price == max_price && newPrice != null && newComparePrice != '' && newPrice < newComparePrice){
           compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency); 
        }
      }
      this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
      if(getCurrentVariant.compare_at_price != null){
        this_section.querySelector('.frenzy_product_price_compare').innerHTML = '<span class="money">'+compare_price+'</span>';  
      }
    });
  })
}

window.FrenzyProductGridChangeCallBack = async function(html, data){
  // console.log("data", data);
  const varint_id = data.product_id_variant.split("_");
  html.querySelector('.frenzy_product_price_meta').classList.add("FrenzyProductId_"+data.product_id);
  html.querySelector('.frenzy_product_price_meta').setAttribute("data-variantid",varint_id[1]);
  html.querySelector('.frenzy_product_price_meta').setAttribute("data-productid",data.product_id);
  html.querySelector('.frenzy_product_item').setAttribute("data-ptemplate",data.template);
  if (data.org_msrp_price > data.org_price && data.org_stock_available) {
    var save_percentage = Math.round((1 - data.org_price / data.org_msrp_price) * 100);
    var save_badge = document.createElement('div');
    save_badge.classList.add('frenzy_product_item_badge');
    save_badge.innerHTML = 'Save up to ' + save_percentage + '%';
    html.querySelector('.frenzy_img_wrapper').append(save_badge);
  }
  
  const product_handle = data.org_prod_url.split("?");

  const max_price = data.org_variant_max_price;
  const min_price = data.org_variant_min_price;
  let price = 0;
  let compare_price = 0;

  

  if(Shopify.currency.active == frenzy_scripts.currency){
    if(min_price != max_price){
        price = '<span> As low as </span>' + money_format_Frenzy(min_price * 100, frenzy_shop_currency);
    }else{
       price =  money_format_Frenzy(data.org_price * 100, frenzy_shop_currency);
      if(min_price == max_price && data.org_msrp_price != null && data.org_msrp_price != '' && data.org_price < data.org_msrp_price){
         compare_price = money_format_Frenzy(data.org_msrp_price * 100, frenzy_shop_currency); 
      }
    }
    html.querySelector('.frenzy_product_price_sale').innerHTML = price;
    
    if(compare_price != 0){
      html.querySelector('.frenzy_product_price_compare').innerHTML = compare_price;
      html.querySelector('.frenzy_product_price_compare').style.display = 'block';
    }
  }else{
    frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html).then(frenzy_product_response => {return frenzy_product_response});
  }
  reviewCallBack(data.product_id,html);
  vendorLogo(data.org_brand,data.sku);
}

function vendorLogo(vendor_name,sku){
      var VHTML = '';
      //console.log(vendor_name);
      if (vendor_name == "Unger") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/unger_1.png?v=1669130648 135w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/unger_1.png?v=1669130648&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="135" height="135">';
      } else if (vendor_name == "Moerman") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Moerman-Brand-Logo-2.png?v=1675271631" loading="lazy">';
      } else if (vendor_name == "XERO") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/xero.png?v=1670272865&amp;width=165 165w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/xero.png?v=1670272865&amp;width=360 360w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/xero.png?v=1670272865&amp;width=535 535w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/xero.png?v=1670272865&amp;width=750 750w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/xero.png?v=1670272865&amp;width=1070 1070w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/xero.png?v=1670272865 1100w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/xero.png?v=1670272865&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="1100" height="300">';
      } else if (vendor_name == "Ettore") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962&amp;width=165 165w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962&amp;width=360 360w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962&amp;width=535 535w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962&amp;width=750 750w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962&amp;width=1070 1070w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962&amp;width=1500 1500w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962 5005w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/logo-ettore.png?v=1670336962&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="5005" height="1134">';
      } else if (vendor_name == "Maykker") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Maykker-Products-Brand-Logo-2.png?v=1675271709" loading="lazy">';
      } else if (vendor_name == "BlackDiamond") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/BlackDiamond-Squeegee-Rubber-Brand-Logo-2.png?v=1675271776" loading="lazy">';
      } else if (vendor_name == "Tucker") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/tucker.png?v=1670336989&amp;width=165 165w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/tucker.png?v=1670336989&amp;width=360 360w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/tucker.png?v=1670336989&amp;width=535 535w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/tucker.png?v=1670336989&amp;width=750 750w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/tucker.png?v=1670336989&amp;width=1070 1070w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/tucker.png?v=1670336989 1100w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/tucker.png?v=1670336989&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="1100" height="300">';
      } else if (vendor_name == "Sorbo") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Sorbo.png?v=1674146208" loading="lazy">';
      } else if (vendor_name == "Wagtail") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/wagtail_1_89047ba8-2446-45a7-bb7b-daae709486ab.png?v=1670337442 135w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/wagtail_1_89047ba8-2446-45a7-bb7b-daae709486ab.png?v=1670337442&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="135" height="135">';
      } else if (vendor_name == "Titan Laboratories") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/titan_64c10c37-2ae0-4b6c-ad15-31cdf56e0b03.png?v=1670337504 135w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/titan_64c10c37-2ae0-4b6c-ad15-31cdf56e0b03.png?v=1670337504&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="135" height="135">';
      } else if (vendor_name == "Triumph") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Triumph.png?v=1674487183" loading="lazy">';
      } else if (vendor_name == "Winsol") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Winsol-Brand-Logo-1.png?v=1675435861" loading="lazy">';
      } else if (vendor_name == "Steccone") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/steccone.png?v=1670337753&amp;width=165 165w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/steccone.png?v=1670337753&amp;width=360 360w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/steccone.png?v=1670337753&amp;width=535 535w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/steccone.png?v=1670337753&amp;width=750 750w,//cdn.shopify.com/s/files/1/0616/1999/4775/files/steccone.png?v=1670337753 759w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/steccone.png?v=1670337753&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="759" height="295">';
      } else if (vendor_name == "Glass Renu") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" srcset="//cdn.shopify.com/s/files/1/0616/1999/4775/files/glass_renu_2_21b5dded-77e1-44ea-b54f-306f3d203bb5.png?v=1670337796 135w" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/glass_renu_2_21b5dded-77e1-44ea-b54f-306f3d203bb5.png?v=1670337796&amp;width=1500" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="" loading="lazy" width="135" height="135">';
      } else if (vendor_name == "MIO") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/MIO-Mechanical-Corporation-Brand-Logo-1-_1.png?v=1675435861" loading="lazy">';
      } else if (vendor_name == "New England Rope") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/neropes.png?v=1675435861" loading="lazy">';
      } else if (vendor_name == "WCR") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" style="width:44px" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/WCR-Logo_1_88da91b6-93b6-4cc7-9a91-5c0952232713.png?v=1673632638" loading="lazy">';
      } else if (vendor_name == "Companion Tools") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Companion_Tools_2.png?v=1673790062" loading="lazy">';
      } else if (vendor_name == "Mr Long Arm Poles") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Mr_Long_Arm_Poles_2.png?v=1673790386" loading="lazy">';
      } else if (vendor_name == "Facelift") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/FaceLift-v2.png?v=1675435669" loading="lazy">';
      } else if (vendor_name == "World Enterprises") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" style="width:70px;height:auto;top:0" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/World_Enterprises.png?v=1674487644" loading="lazy">';
      } else if (vendor_name == "Glacier Glove") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" style="width:70px;top:0" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/Glacier_outdoor_blue_seal_logo.webp?v=1675761403" loading="lazy">';
      } else if (vendor_name == "Youngstown") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" style="width:70px" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/ygc_logo_opt_410x_fb0ba4f3-3e7c-464e-ba68-96866f49c04b.webp?v=1675761742" loading="lazy">';
      } else if (vendor_name == "OVA8") {
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo" style="width:70px" src="//cdn.shopify.com/s/files/1/0616/1999/4775/files/ova8-final-logo-01.png?v=1676910162" loading="lazy">';
      } else {
        var vendor_image_name = vendor_name;
        if (vendor_image_name.indexOf(' ') != -1) {
            vendor_image_name = vendor_image_name.replace(/\s/g, '-');
        }
        var url = "//cdn.shopify.com/s/files/1/0616/1999/4775/files/"+vendor_image_name+".png";
        VHTML = '<img alt="'+vendor_name+'" class="vendor-logo new-logo" src="'+url+'" loading="lazy" onerror="removeElement(this)">';
      }  

       // VHTML = '<div class="brand_section">'+VHTML+'</div>';
      setTimeout(function(){
        if(jQuery('.frenzy_product_item[data-id="'+sku+'"]').find('figure').find('.vendor-logo').length == 0){
           jQuery(VHTML).insertBefore(jQuery('.frenzy_product_item[data-id="'+sku+'"]').find('figure').find(".frenzy_product_tags")); 
        }
      },200);
}
function reviewCallBack(product_id,gridHtml){
  var product_ids = {"productIds":[{productId: product_id}],"apiKey":"85577952-f745-44a4-a8fd-5b7a331c70df","storeUrl":Shopify.shop};
  var xhr = new XMLHttpRequest();
  xhr.open('POST', 'http://stamped.io/api/widget/badges?isIncludeBreakdown=true&isincludehtml=true', true);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.onload = function () {
    var ratting_obj = this.responseText ? JSON.parse(this.responseText) : {};
    let rating_decimal = 0;
    let rattingText = 'review';
    ratting_obj = ratting_obj[0];
    
    if(ratting_obj.rating > 0){
      ratting_obj.rating = ratting_obj.rating.toFixed(1);
      let decimal = (ratting_obj.rating % 1);

      if(decimal ===0){
        ratting_obj.rating = Math.round(ratting_obj.rating);
      }
      
      if(decimal >= 0.3 && decimal <= 0.7){
        rating_decimal = 0.5;
      }else if(decimal > 0.7){
        rating_decimal = 1;
      }
      if(ratting_obj.count > 1){
        rattingText = 'reviews';
      }
      var html = '<div class="review-stars-block">';
      html += ratting_obj.badge;
      html += '</div>';
      if(jQuery('.frenzy_product_price_meta[data-productid="'+ratting_obj.productId+'"]').parents('.frenzy_product_item').find('.review-stars-block').length == 0){
         jQuery(html).insertBefore(jQuery('.frenzy_product_price_meta[data-productid="'+ratting_obj.productId+'"]').parents('.frenzy_product_item').find(".frenzy_product_buttom")); 
      }
    }
    
  };
  xhr.send(JSON.stringify(product_ids));
}

window.FrenzyPopStateCallBack = function(){
  if(__st && __st.p != 'home'){
    window.location.reload(); 
  }
}
window.frenzyFilterClickCallBack = function(){
  if(document.querySelector('.frenzy_collections_page')){
     $('html, body').animate({
      scrollTop: $('.frenzy_collections_page').offset().top - 230,
    });
  }else{
    document.querySelector("body").scrollIntoView({ behavior: "smooth" });
  }
}
window.frenzyCartCallBack = async (res) => {
// window.FrenzyBundleAddtoCartRedirectCallBack = async (res) => {
  var t = {'cart-drawer': document.querySelector('cart-drawer')}
  // document.querySelector('cart-drawer').open();
    const $this_cart_type = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const $get_section_content_url = '/?sections=cart-notification-product,cart-notification-button,cart-icon-bubble';
  let $cart_item_first_val = res.items[2] ? res.items[2] : res.items[0];
  fetch($get_section_content_url, {
    method: "GET"
  }).then((response) => response.json()).then((data) => {
    $cart_item_first_val['sections'] = data;
    const quickAddModal = document.querySelector('quick-add-modal');
    document.querySelector('.frenzy_loading_spinner').remove();
    if (quickAddModal) {
      document.body.addEventListener('modalClosed', () => {
        setTimeout(() => { $this_cart_type.renderContents($cart_item_first_val) });
      }, { once: true });
      quickAddModal.hide(true);
    } else {
      $this_cart_type.renderContents($cart_item_first_val);
    }
    if ($this_cart_type && $this_cart_type.classList.contains('is-empty')) $this_cart_type.classList.remove('is-empty');
  });
  frenzyAsyncItems();
}

const bundle_frenzy_get_product_json = async function(url, html,settingData){
  jQuery.getJSON(url, function(product) {
        
          var getVariantID = parseInt(html.value);
          const $frenzy_bundle_parent = html.closest(
                    ".frenzy_bundle_innercode"
                  );
          // const getVariantID = this_section.getAttribute("data-variantid");
          const getCurrentVariant = (product?.product?.variants || product.variants || []).find((y) => (y.id === getVariantID));

          const newPrice = getCurrentVariant.price / 100;
          const newComparePrice = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price : 0 / 100;
          const max_price = product.price_max;
          const min_price = product.price_min;
          var compare_price = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price : 0 / 100;
          var price = '';

         
          if(min_price != max_price){
              // price = money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
            price = newPrice * 100;
          }else{
            // price =  money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
            price =  newPrice * 100;
            if(min_price == max_price && newPrice != null && newComparePrice != '' && newPrice < newComparePrice){
               // compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency); 
               compare_price = newComparePrice;
            }
          }
      var frenzy_bundle_sale_price =price;
     if(settingData?.discount_amount > 0){
                    is_discount = true;
                frenzy_bundle_sale_price =
                  settingData?.discount_type == "percentage" ? (price  * (100 - settingData?.discount_amount)) / 100 :price  - settingData?.discount_amount * 100;
            }
          // html.querySelector('.frenzy_bundle_product_main_price').innerHTML = '<span class="money">'+price+'</span>';
        
           html.setAttribute('data-price',frenzy_bundle_sale_price);
           html.setAttribute('data-orgprice',price);
          if(compare_price != ''){
            html.setAttribute('data-org_msrp_price',compare_price);
          }else{
            // html.setAttribute('data-org_msrp_price',price);
          }
          $frenzy_bundle_final_total(
                    $frenzy_bundle_parent,
                    settingData
                  );
  })
}
const FrenzyAfterBundlePriceChangeCallBack = async function(data,settingData){
  const variant_option_type = settingData?.select_option == "all_options" ? "all_options" : "size";
  document.querySelectorAll('.frenzy_pb_details .frenzy_bundle_product_grid').forEach(function(this_click){
    var product_handle = this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val').getAttribute('data-handle');
     var html =  this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val');
     var product_handle = product_handle.split('?');
    bundle_frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html,settingData).then(frenzy_product_response => {return frenzy_product_response});
  });
}
var bundleStatus = 0;
window.frenzAfterApiCallBack = function(){
  if(document.querySelector('.frenzy_bundle_id')){
    
    var checkedCount = 0;
      if(document.querySelector('.frenzy_bundle_id').querySelector('.frenzy_pb_details')){

        const bundle_button = document.querySelector('.frenzy_bundle_cta_atc');
        bundle_button.classList.add('product-form--atc-button', 'mdc-ripple-surface', 'mdc-ripple-upgraded');
        
        if(bundleStatus != 1){
          var frenzy_bundle_product_grid =  document.querySelector('.frenzy_bundle_id .frenzy_pb_details').querySelectorAll('.frenzy_bundle_product_grid');
          var frenzy_bundle_product_grid1 =  document.querySelector('.frenzy_bundle_id .frenzy_pb_details');
          var BundleProductCount = FrenzyCustomBundle(frenzy_bundle_product_grid1);
          FrenzyUpdateBundleProductCount(BundleProductCount);
          frenzy_bundle_product_grid.forEach(function(this_grid){
            var GridCheckBox = this_grid.querySelector('.frenzy_bundle_product_checkbox_val');
            if(GridCheckBox){
              GridCheckBox.addEventListener('change', function(this_click){
                var BundleProductCount = FrenzyCustomBundle(frenzy_bundle_product_grid1);
                FrenzyUpdateBundleProductCount(BundleProductCount);
              });
            }
          });
          bundleStatus = 1;
        }
      }
  }
}
function FrenzyCustomBundle(frenzy_bundle_product_grid){
  var checkedCount = 0;
  if(frenzy_bundle_product_grid){
    var cheboxLength = frenzy_bundle_product_grid.querySelectorAll('.frenzy_bundle_product_checkbox_val:checked').length;
    if(cheboxLength > 1){
      checkedCount = cheboxLength;
    }else{
      checkedCount = 1;
    }
  }
  return checkedCount;
}
function FrenzyUpdateBundleProductCount(BundleProductCount){
  if(document.querySelector('.frenzy_bundle_id').querySelector('.frenzy_bundle_cta_inner')){
    if(BundleProductCount > 1){
      document.querySelector('.frenzy_bundle_id').querySelector('.frenzy_bundle_cta_inner').querySelector('.frenzy_button_text').innerText = 'Add All '+BundleProductCount+ ' to Cart';  
    }else{
      document.querySelector('.frenzy_bundle_id').querySelector('.frenzy_bundle_cta_inner').querySelector('.frenzy_button_text').innerText = 'Add to Cart';
    }
    
  }
}